import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE, PAGE_META } from "../data/content";

const NO_INDEX = ["/admin"];

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

export default function RouteMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname.length > 1 ? pathname.replace(/\/$/, "") : pathname;
    const known = Boolean(PAGE_META[path]) && (path !== "/privacy" || SITE.privacyPolicyApproved);
    const meta = known ? PAGE_META[path] : { title: "Page not found | Elk Creek Marina", description: PAGE_META["/"].description };
    const url = `${SITE.siteUrl}${known ? path : "/"}`;
    document.title = meta.title;
    setMeta('meta[name="robots"]', "content", known && !NO_INDEX.includes(path) ? "index, follow" : "noindex, nofollow");
    setMeta('meta[name="description"]', "content", meta.description);
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:title"]', "content", meta.title);
    setMeta('meta[property="og:description"]', "content", meta.description);
    setMeta('meta[name="twitter:title"]', "content", meta.title);
    setMeta('meta[name="twitter:description"]', "content", meta.description);
  }, [pathname]);

  return null;
}
